import Clazz from './Clazz';

/**
 * 工厂类的基类
 */
export default class Factory extends Clazz {
    /**
     * 构造函数
     * @param  {object}     options 其他参数
     * @return {undefined}
     */
    constructor(options) {
        const defaultOptions = {
            mode: 1, // 模式：1.键值唯一；2.键值不唯一
            copacity: 0, // 容量：0，无限制；大于0，数据长度不能大于此值，大于时才用先进先出的原则，对已有数据进行删除
        };
        
        super({
            ...defaultOptions,
            ...options
        });

        /**
         * 资源数据
         * @type {array<object>}
         */
        this._resources = [];
    }

    /**
     * 获取资源数据
     * @return {object} 键值对对象
     */
    get resources() {
        return this._resources;
    }

    /**
     * 设置容量
     * @param  {Number}    value   最大值
     * @return {undefined}
     */
    setCapacity(value) {
        this.options.capacity = value;
    }

    /**
     * 根据多个参数，拼接成key字符串
     * @param {string|number} keyString 
     */
    createKey(...keyString) {
        return keyString.map(it => (it === undefined || it === null ? '' : it)).join('-');
    }

    /**
     * 添加数据
     * @param  {string}  key   键值
     * @param  {all}     value 内容
     * @return {boolean} 是否成功
     */
    add(key, value) {
        if (!key || !value) {
            return false;
        }
        if (this.options.mode === 1) {
            const val = this.get(key);
            if (val.length > 0) {
                return false;
            }
        }
        if (this.options.capacity > 0 && this._resources.length === this.options.capacity) {
            this._resources.shift();
        }

        this._resources.push({
            key,
            value
        });

        return true;
    }

    /**
     * 删除数据
     * @param {string} key 键值
     * @return {undefined}
     */
    remove(key) {
        if (!key) {
            return false;
        }

        for (let i = 0; i < this._resources.length; ++i) {
            const res = this._resources[i];
            if (res.key === key) {
                this._resources.splice(i--, 1);
            }
        }

        return true;
    }

    /**
     * 根据键值获取内容
     * @param {string} key 键值
     */
    get(key) {
        const values = [];
        for (let i = 0; i < this._resources.length; ++i) {
            const res = this._resources[i];
            if (res.key === key) {
                values.push(res.value);

                if (this.options.mode === 1) {
                    break;
                }
            }
        }

        return values;
    }

    /**
     * 清空
     * @returns {undefined}
     */
    clear() {
        this._resources = [];
    }
}
